export const FETCH_NOTIFICATION_DATA_REQUEST = 'FETCH_NOTIFICATION_DATA_REQUEST';
export const FETCH_NOTIFICATION_DATA_SUCCESS = 'FETCH_NOTIFICATION_DATA_SUCCESS';
export const FETCH_NOTIFICATION_DATA_FAILURE = 'FETCH_NOTIFICATION_DATA_FAILURE';